<template lang="pug">
  .root
    Base(:liveType="liveType")

</template>

<style src="./Normal.scss" lang="scss" scoped>

</style>

<script>
import Base from './components/Base'
import {LIVE_TYPE} from './helper/def'

export default {
  name: "TopLiveNormal",
  components: {
    Base
  },
  data() {
    return {
      liveType: LIVE_TYPE.NORMAL
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {},
  updated() {},
  async destroyed() {},
  methods: {}
};
</script>
